module.exports = __webpack_public_path__ + "static/img/integral_img1.152b7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integral_img1.png
// module id = zIRq
// module chunks = 55